import React, { useMemo } from "react";
import { Box, Text } from "@chakra-ui/react";
import { TableVirtuoso } from "react-virtuoso";
import { DOCUMENT_LINES_COLUMNS, LABEL } from "../../../../constants";

const formatDate = (ts) => (ts ? new Date(ts).toISOString().split("T")[0] : "");
const formatNumber = (n) =>
  typeof n === "number" && !Number.isNaN(n)
    ? n.toLocaleString(undefined, { maximumFractionDigits: 4 })
    : "";

export const DocumentLinesReadOnlyTable = ({lines}) => {
  const safeLines = Array.isArray(lines) ? lines : [];

  const columns = DOCUMENT_LINES_COLUMNS;

  const totalWidth = useMemo(
    () => columns.reduce((sum, c) => sum + (c.w || 120), 0),
    [columns]
  );

  const cellFor = (col, row, index) => {
    switch (col.key) {
      case "index": return index + 1;
      case "details": return row.details || "";
      case "quantity": return formatNumber(row.quantity);
      case "unitPriceWithoutVat": return formatNumber(row.unitPriceWithoutVat);
      case "vatValue": return formatNumber(row.vatValue);
      case "invoicePeriodStartDate": return formatDate(row.invoicePeriodStartDate);
      case "invoicePeriodEndDate": return formatDate(row.invoicePeriodEndDate);
      default: return row[col.key] ?? "";
    }
  };

  return (
    <Box>
      <Text borderBottom="1px solid" borderColor="gray.200" mb={2} p={2} pl={0}>
        Listă articole
      </Text>

      <Box
        bg="white"
        border="1px solid"
        borderColor="gray.200"
        rounded="md"
        h="520px"
      >
        <TableVirtuoso
          data={safeLines}
          style={{ height: "100%" }}
          fixedHeaderContent={() => (
            <tr>
              {columns.map((c) => (
                <th
                  key={c.key}
                  style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                    background: "var(--chakra-colors-gray-50)",
                    borderBottom: "1px solid var(--chakra-colors-gray-200)",
                    fontSize: "0.875rem",
                    textAlign: "left",
                    padding: "6px 8px",
                    minWidth: c.w,
                    width: c.w,
                    maxWidth: c.w,
                    boxSizing: "border-box",
                  }}
                >
                  {c.label}
                </th>
              ))}
            </tr>
          )}
          itemContent={(index, row) => (
            <>
              {columns.map((c) => (
                <td
                  key={c.key}
                  style={{
                    padding: "6px 8px",
                    borderBottom: "1px solid var(--chakra-colors-gray-100)",
                    verticalAlign: "top",
                    minWidth: c.w,
                    width: c.w,
                    maxWidth: c.w,
                    boxSizing: "border-box",
                    whiteSpace: c.key === "details" ? "pre-wrap" : "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                  title={c.key === "details" ? undefined : String(cellFor(c, row, index))}
                >
                  {cellFor(c, row, index)}
                </td>
              ))}
            </>
          )}
          components={{
            Table: (props) => (
              <table
                {...props}
                style={{
                  tableLayout: "fixed",
                  width: totalWidth,
                  minWidth: "100%",
                  borderCollapse: "separate",
                  borderSpacing: 0,
                  ...(props.style || {}),
                }}
              />
            ),
          }}
        />
      </Box>

      <Text mt={2} fontSize="xs" color="gray.500">
        * Modificările se fac prin import Excel.
      </Text>
    </Box>
  );
}
